import { render, staticRenderFns } from "./Earth.vue?vue&type=template&id=a4bd322e"
import script from "./Earth.vue?vue&type=script&lang=js"
export * from "./Earth.vue?vue&type=script&lang=js"
import style0 from "./Earth.vue?vue&type=style&index=0&id=a4bd322e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports